import { render, staticRenderFns } from "./Nuevo-vendedor.vue?vue&type=template&id=680d4159&scoped=true"
import script from "./Nuevo-vendedor.vue?vue&type=script&lang=js"
export * from "./Nuevo-vendedor.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-vendedor.vue?vue&type=style&index=0&id=680d4159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d4159",
  null
  
)

export default component.exports